import React from 'react';
import ReactMarkdown from 'react-markdown';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import termsContent from './termsContent.ts';

interface TermsDialogProps {
  open: boolean;
  onClose: () => void;
}

const TermsDialog: React.FC<TermsDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Terms and Conditions</DialogTitle>
          <DialogDescription>
            Please read these terms and conditions carefully before using Naptune.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4 space-y-4 text-sm">
          <ReactMarkdown
            components={{
              // eslint-disable-next-line jsx-a11y/heading-has-content
              h1: ({ node, ...props }) => <h1 className="text-2xl font-bold mt-6 mb-4 first:mt-0" {...props} />,
              // eslint-disable-next-line jsx-a11y/heading-has-content
              h2: ({ node, ...props }) => <h2 className="text-xl font-semibold mt-5 mb-3" {...props} />,
              // eslint-disable-next-line jsx-a11y/heading-has-content
              h3: ({ node, ...props }) => <h3 className="text-lg font-medium mt-4 mb-2" {...props} />,
              p: ({ node, ...props }) => <p className="mb-4 leading-relaxed" {...props} />,
              ul: ({ node, ...props }) => <ul className="list-disc list-inside mb-4 space-y-2 ml-4" {...props} />,
              ol: ({ node, ...props }) => <ol className="list-decimal list-inside mb-4 space-y-2 ml-4" {...props} />,
              li: ({ node, ...props }) => <li className="mb-1" {...props} />,
              hr: ({ node, ...props }) => <hr className="my-6 border-border" {...props} />,
              em: ({ node, ...props }) => <em className="italic" {...props} />,
              strong: ({ node, ...props }) => <strong className="font-semibold" {...props} />,
            }}
          >
            {termsContent}
          </ReactMarkdown>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TermsDialog;
